module.exports = __webpack_public_path__ + "static/media/chef.d6064bc0.svg";